import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import AttachmentsForm, {
  onAttachmentEvent,
  onAttachmentsTabSelected
} from "@/protected/components/AttachmentsForm";
import service from "./ProviderService";
import ProviderForm from "./ProviderForm";

const contextList = [
  {
    label: "Allegati fornitore - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "providers",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.attachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questo " +
      '<strong class="text-primary">fornitore</strong>.'
  },
  {
    label: "Allegati fornitore - Visibilità: Gestori/Fornitori",
    serverPath: "providers",
    subcontext: "BROKER_PROVIDER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">fornitori</strong>, ma ' +
      'non dai <strong class="text-danger">clienti</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questo " +
      '<strong class="text-primary">fornitore</strong>.'
  }
];

export default {
  mixins: [AppEditorMixin],

  computed: {
    tabs() {
      return [
        {
          component: ProviderForm,
          title: () => this.$t("provider.tabs.main"),
          icon: "user"
        },
        {
          id: "attachments",
          component: AttachmentsForm,
          title: () => this.$t("provider.tabs.attachments"),
          icon: "paperclip",
          show: !this.isNew,
          props: {
            contextList
          },
          events: {
            "attachment-event": onAttachmentEvent.bind(this)
          },
          tabSelected: onAttachmentsTabSelected.bind(this)
        }
      ];
    }
  },

  methods: {
    getService() {
      return service;
    }
  }
};
